import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ReaderActions from "./ReaderActions";
import PdfActionBar from "./PdfActionBar";
import TabNavigation from "../../LeftPanel/TabNavigation";
import { VIEWS } from "../../consts";
import NavigateHighlights from "./NavigateHighlights";

const useStyles = makeStyles((theme) => ({
  actionBarWrapper: {
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    width: "100%",
    backgroundColor: theme.palette.background.paper
  },
  actionBar: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "56px",
    backgroundColor: theme.palette.grey.paper,
    boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.1)",
    width: "auto"
  },
  actionGroup: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginInlineEnd: theme.spacing(2)
  },
  combinedViewSwitch: {
    marginLeft: theme.spacing(2),
    fontSize: "14px",
    "& .MuiFormControlLabel-label": {
      fontSize: "14px"
    },
    "& .MuiSwitch-switchBase": {
      "&.Mui-checked": {
        color: theme.palette.primary.main,
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.blue.tertiary,
          opacity: 0.7
        }
      }
    }
  }
}));

const MainActionBar = ({
  contentWidth,
  activeMode,
  handleModeChange,
  combinedViewMode,
  setCombinedViewMode
}) => {
  const classes = useStyles();
  const isReaderView = activeMode === VIEWS.READER;
  const previousModeRef = useRef(VIEWS.READER);

  // Keep track of the previous mode when not in combined view
  useEffect(() => {
    // Only update the ref if we're not in combined view
    if (activeMode !== VIEWS.COMBINED) {
      previousModeRef.current = activeMode;
    }
  }, [activeMode]);

  // Handler function that accepts an explicit parameter to force a state
  const handleCombinedViewToggle = (forceState = null) => {
    // Set the new state - either forced or toggled
    const newCombinedViewState =
      forceState !== null ? forceState : !combinedViewMode;

    // Update the combined view state first
    setCombinedViewMode(newCombinedViewState);

    // Important: Mode changes should be synchronous with combined view changes
    if (newCombinedViewState) {
      // Switching TO combined view
      handleModeChange(VIEWS.COMBINED);
    } else if (activeMode === VIEWS.COMBINED) {
      // Only restore if currently in combined view
      handleModeChange(previousModeRef.current);
    }
  };

  // Common components - pass combined view props to ReaderActions
  const readerActionsComponent = (
    <ReaderActions
      activeMode={activeMode}
      onModeChange={handleModeChange}
      contentWidth={contentWidth}
      combinedViewMode={combinedViewMode}
      handleCombinedViewToggle={handleCombinedViewToggle}
    />
  );

  // View-specific components
  const readerViewComponents = (
    <>
      <NavigateHighlights />
      <PdfActionBar contentWidth={contentWidth} />
      {readerActionsComponent}
    </>
  );

  const standardViewComponents = (
    <>
      {readerActionsComponent}
      {/* <FormControlLabel
        control={
          <Switch
            checked={combinedViewMode}
            onChange={() => handleCombinedViewToggle()}
            className={classes.combinedViewSwitch}
          />
        }
        label="Combined view"
        labelPlacement="start"
      /> */}
    </>
  );

  return (
    <Box className={classes.actionBarWrapper}>
      <Box className={classes.actionBar}>
        <TabNavigation
          activeMode={activeMode}
          onModeChange={handleModeChange}
          handleCombinedViewToggle={handleCombinedViewToggle}
          combinedViewMode={combinedViewMode}
        />
        <Box className={classes.actionGroup}>
          {isReaderView ? readerViewComponents : standardViewComponents}
        </Box>
      </Box>
    </Box>
  );
};

export default MainActionBar;
